/**
 * Gift bag / gift wrap pickers — cart drawer integration.
 *
 * Supports multiple independent pickers on the same page (e.g. gift bag
 * size picker + gift wrap pattern picker). Each picker element needs:
 *   - a wrapping element with [data-gift-wrap-picker]
 *   - radio inputs with [data-variant-id] holding the variant ID
 *   - a submit button with [data-add-gift-wrap]
 *   - a status message element with [data-gift-wrap-status]
 *
 * Adds the selected variant to the cart via Shopify's native AJAX Cart
 * API, then triggers this theme's native drawer refresh event.
 */

document.addEventListener('DOMContentLoaded', () => {
  const pickers = document.querySelectorAll('[data-gift-wrap-picker]');
  if (!pickers.length) return;

  pickers.forEach((picker) => {
    const submitBtn = picker.querySelector('[data-add-gift-wrap]');
    const statusEl = picker.querySelector('[data-gift-wrap-status]');

    submitBtn.addEventListener('click', async () => {
      const selected = picker.querySelector('input[type="radio"]:checked');

      if (!selected) {
        statusEl.textContent = 'Please choose an option first.';
        return;
      }

      const variantId = selected.dataset.variantId;

      submitBtn.disabled = true;
      const originalLabel = submitBtn.textContent;
      submitBtn.textContent = 'Adding...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: {
                  _gift_wrap: 'true'
                }
              }
            ]
          })
        });

        if (!response.ok) {
          throw new Error(`Cart add failed: ${response.status}`);
        }

        statusEl.textContent = 'Added to your order.';

        // This theme's cart-drawer.js listens for this exact event and
        // calls cart-form.refresh() internally.
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));

      } catch (error) {
        console.error('Gift wrap add-to-cart error:', error);
        statusEl.textContent = 'Something went wrong. Please try again.';
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
      }
    });
  });
});
